/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectReport } from './ProjectReport';
import {
    ProjectReportFromJSON,
    ProjectReportFromJSONTyped,
    ProjectReportToJSON,
    ProjectReportToJSONTyped,
} from './ProjectReport';
import type { ProjectLegacyReport } from './ProjectLegacyReport';
import {
    ProjectLegacyReportFromJSON,
    ProjectLegacyReportFromJSONTyped,
    ProjectLegacyReportToJSON,
    ProjectLegacyReportToJSONTyped,
} from './ProjectLegacyReport';
import type { ProjectPermission } from './ProjectPermission';
import {
    ProjectPermissionFromJSON,
    ProjectPermissionFromJSONTyped,
    ProjectPermissionToJSON,
    ProjectPermissionToJSONTyped,
} from './ProjectPermission';
import type { SubscriptionData } from './SubscriptionData';
import {
    SubscriptionDataFromJSON,
    SubscriptionDataFromJSONTyped,
    SubscriptionDataToJSON,
    SubscriptionDataToJSONTyped,
} from './SubscriptionData';
import type { SensitiveMetric } from './SensitiveMetric';
import {
    SensitiveMetricFromJSON,
    SensitiveMetricFromJSONTyped,
    SensitiveMetricToJSON,
    SensitiveMetricToJSONTyped,
} from './SensitiveMetric';
import type { BillingAccountData } from './BillingAccountData';
import {
    BillingAccountDataFromJSON,
    BillingAccountDataFromJSONTyped,
    BillingAccountDataToJSON,
    BillingAccountDataToJSONTyped,
} from './BillingAccountData';

/**
 * 
 * @export
 * @interface ProjectDataWithPermissions
 */
export interface ProjectDataWithPermissions {
    /**
     * 
     * @type {string}
     * @memberof ProjectDataWithPermissions
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataWithPermissions
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataWithPermissions
     */
    logoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataWithPermissions
     */
    currency?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDataWithPermissions
     */
    hasErpIntegration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDataWithPermissions
     */
    hasLeadIntegration?: boolean;
    /**
     * 
     * @type {BillingAccountData}
     * @memberof ProjectDataWithPermissions
     */
    billingAccount?: BillingAccountData | null;
    /**
     * 
     * @type {SubscriptionData}
     * @memberof ProjectDataWithPermissions
     */
    subscription?: SubscriptionData | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDataWithPermissions
     */
    shoptetCustomerClassificationAvailable?: boolean;
    /**
     * 
     * @type {Array<ProjectPermission>}
     * @memberof ProjectDataWithPermissions
     */
    permissions?: Array<ProjectPermission>;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDataWithPermissions
     */
    isOwner?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ProjectDataWithPermissions
     */
    lastInteraction?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectDataWithPermissions
     */
    forbiddenChannels?: Array<string>;
    /**
     * 
     * @type {Array<ProjectReport>}
     * @memberof ProjectDataWithPermissions
     */
    allowedReports?: Array<ProjectReport>;
    /**
     * 
     * @type {Array<ProjectLegacyReport>}
     * @memberof ProjectDataWithPermissions
     */
    allowedLegacyReports?: Array<ProjectLegacyReport>;
    /**
     * 
     * @type {Array<SensitiveMetric>}
     * @memberof ProjectDataWithPermissions
     */
    sensitiveMetrics?: Array<SensitiveMetric>;
}

/**
 * Check if a given object implements the ProjectDataWithPermissions interface.
 */
export function instanceOfProjectDataWithPermissions(value: object): value is ProjectDataWithPermissions {
    return true;
}

export function ProjectDataWithPermissionsFromJSON(json: any): ProjectDataWithPermissions {
    return ProjectDataWithPermissionsFromJSONTyped(json, false);
}

export function ProjectDataWithPermissionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDataWithPermissions {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'hasErpIntegration': json['hasErpIntegration'] == null ? undefined : json['hasErpIntegration'],
        'hasLeadIntegration': json['hasLeadIntegration'] == null ? undefined : json['hasLeadIntegration'],
        'billingAccount': json['billingAccount'] === undefined ? undefined : json['billingAccount'] === null ? null : BillingAccountDataFromJSON(json['billingAccount']),
        'subscription': json['subscription'] === undefined ? undefined : json['subscription'] === null ? null : SubscriptionDataFromJSON(json['subscription']),
        'shoptetCustomerClassificationAvailable': json['shoptetCustomerClassificationAvailable'] == null ? undefined : json['shoptetCustomerClassificationAvailable'],
        'permissions': json['permissions'] == null ? undefined : ((json['permissions'] as Array<any>).map(ProjectPermissionFromJSON)),
        'isOwner': json['isOwner'] == null ? undefined : json['isOwner'],
        'lastInteraction': json['lastInteraction'] == null ? undefined : (new Date(json['lastInteraction'])),
        'forbiddenChannels': json['forbiddenChannels'] == null ? undefined : json['forbiddenChannels'],
        'allowedReports': json['allowedReports'] == null ? undefined : ((json['allowedReports'] as Array<any>).map(ProjectReportFromJSON)),
        'allowedLegacyReports': json['allowedLegacyReports'] == null ? undefined : ((json['allowedLegacyReports'] as Array<any>).map(ProjectLegacyReportFromJSON)),
        'sensitiveMetrics': json['sensitiveMetrics'] == null ? undefined : ((json['sensitiveMetrics'] as Array<any>).map(SensitiveMetricFromJSON)),
    };
}

export function ProjectDataWithPermissionsToJSON(json: any): ProjectDataWithPermissions {
    return ProjectDataWithPermissionsToJSONTyped(json, false);
}

export function ProjectDataWithPermissionsToJSONTyped(value?: ProjectDataWithPermissions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'logoUrl': value['logoUrl'],
        'currency': value['currency'],
        'hasErpIntegration': value['hasErpIntegration'],
        'hasLeadIntegration': value['hasLeadIntegration'],
        'billingAccount': BillingAccountDataToJSON(value['billingAccount']),
        'subscription': SubscriptionDataToJSON(value['subscription']),
        'shoptetCustomerClassificationAvailable': value['shoptetCustomerClassificationAvailable'],
        'permissions': value['permissions'] == null ? undefined : ((value['permissions'] as Array<any>).map(ProjectPermissionToJSON)),
        'isOwner': value['isOwner'],
        'lastInteraction': value['lastInteraction'] == null ? value['lastInteraction'] : value['lastInteraction'].toISOString(),
        'forbiddenChannels': value['forbiddenChannels'],
        'allowedReports': value['allowedReports'] == null ? undefined : ((value['allowedReports'] as Array<any>).map(ProjectReportToJSON)),
        'allowedLegacyReports': value['allowedLegacyReports'] == null ? undefined : ((value['allowedLegacyReports'] as Array<any>).map(ProjectLegacyReportToJSON)),
        'sensitiveMetrics': value['sensitiveMetrics'] == null ? undefined : ((value['sensitiveMetrics'] as Array<any>).map(SensitiveMetricToJSON)),
    };
}

